define('app/sf/route/sf-route-filter',[],function () {
	"use strict";
	return sfRouteFilter;
	function sfRouteFilter(route) {
		return angular.filter(route, notReplace);
		function notReplace(value, key) {
			return key !== "$replace";
		}
	}
});
